module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td class="center"><input type="checkbox" class="check-person"></td>\n<td><a href = "/#person/'+
((__t=( id ))==null?'':__t)+
'" target="_blank">'+
((__t=( id ))==null?'':__t)+
'</a></td>\n<td>'+
((__t=( object.lastName ))==null?'':__t)+
'</td>\n<td>'+
((__t=( object.firstName ))==null?'':__t)+
'</td>\n<td>'+
((__t=( object.middleName ))==null?'':__t)+
'</td>\n<td>'+
((__t=( birthDate ))==null?'':__t)+
'</td>\n<td>'+
((__t=( object.ssn ))==null?'':__t)+
'</td>\n<td>'+
((__t=( object.npi ))==null?'':__t)+
'</td>\n';
 if (active) { 
__p+='\n<td>Active</td>\n<td><span class="glyphicon glyphicon-remove clickable deactivate" uid="'+
((__t=( id ))==null?'':__t)+
'"/></td>\n';
 } else { 
__p+='\n<td>Not active</td>\n<td><span class="glyphicon glyphicon-play clickable activate" uid="'+
((__t=( id ))==null?'':__t)+
'"/></td>\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/persons/person-item.html
// module id = 338
// module chunks = 0